<script>
export default {
  props: {
    text: {
      default: null,
      type: String,
    },
    backgroundColor: {
      default: '#fff',
      type: String,
    },
    type: {
      default: 'light',
      type: String,
    },
    radius: {
      default: '10px',
      type: String,
    },
    active: {
      default: 'false',
      type: String,
    },
  },
  computed: {
    /**
     * For dynamic background-color
     */
    slideBackground() {
      return {
        '--buttonSlidesBackgroundColor': this.backgroundColor,
      }
    },
    /**
     * For dynamic border-radius
     */
    buttonRadius() {
      return {
        '--buttonSlidesBorderRadius': this.radius,
      }
    },
    /**
     * For dynamic text color
     */
    varian() {
      var varian
      var text
      if (this.type === 'light') {
        varian = '#fff'
        text = '#1f1f1f'
      } else {
        varian = '#1f1f1f'
        text = '#fff'
      }
      return {
        '--buttonSlidesTextColor': text,
        '--buttonSlidesVarian': varian,
      }
    },
  },
}
</script>

<template>
  <b-button
    :class="[$style.backgroundSlides, active === 'true' ? $style.active : '']"
    :style="[slideBackground, varian, buttonRadius]"
    >{{ text }}</b-button
  >
</template>

<style lang="scss" scoped>
.btn {
  z-index: 1;
  width: 100%;
  padding: 1.25rem 3rem;
  font-weight: 600;
  text-align: left;
  border: none;
  &.active {
    color: var(--buttonSlidesVarian);
    background-color: var(--buttonSlidesBackgroundColor) !important;
  }
}
</style>

<style lang="scss" module>
@import '@design';
.backgroundSlides {
  position: relative;
  color: var(--buttonSlidesTextColor);
  background-color: var(--buttonSlidesVarian);
  border-radius: var(--buttonSlidesBorderRadius);
  &:focus,
  &.active {
    color: var(--buttonSlidesVarian);
    background-color: var(--buttonSlidesBackgroundColor) !important;
  }
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 1rem;
    height: 100%;
    content: '';
    background-color: var(--buttonSlidesBackgroundColor);
    border-top-left-radius: var(--buttonSlidesBorderRadius);
    border-bottom-left-radius: var(--buttonSlidesBorderRadius);
    transition: all 0.3s ease-in-out;
  }
  &:hover {
    color: var(--buttonSlidesVarian);
    background-color: var(--buttonSlidesVarian);
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100% !important;
      height: 100%;
      content: '';
      background-color: var(--buttonSlidesBackgroundColor);
      border-radius: var(--buttonSlidesBorderRadius);
      transition: width 0.3s ease-in-out;
    }
  }
}
</style>
